import { DealFilingSection } from "@/types/deals.types";
import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import useArticleSection from "@FillInTableContainer/hooks/useArticleSection";
import { TableCreatorGroupTableTitle } from "@FillInTableContainer/shared";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";
import { TableCreatorTableList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { isRequiredGroupTable } from "@FillInTableContainer/shared/utils/getOptionsFromData";
import { getGroupTableTitle } from "@FillInTableContainer/shared/utils/getTextFromData";

import DealsDealTypeTable from "./components/DealsDealTypeTable/DealsDealTypeTable";
import * as S from "./DealsDealTypeGroupTable.style";

interface Props {
  groupTableKey: DealFilingSection;
  tableList: TableCreatorTableList;
  groupTableIndex: number;
}

const DealsDealTypeGroupTable = ({
  groupTableKey,
  groupTableIndex,
  tableList,
}: Props) => {
  const { register } = useScroll();
  const articleSection = useArticleSection();

  const { checkDisableEdit } = useCanEditGroupTable();

  return (
    <S.GroupTableWrapper
      isDisableEdit={checkDisableEdit(groupTableKey)}
      {...register(groupTableKey)}
    >
      <TableCreatorGroupTableTitle
        title={getGroupTableTitle(articleSection, groupTableKey)}
        isRequired={isRequiredGroupTable(articleSection, groupTableKey)}
      />
      <S.TableCreatorTableListWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
      >
        {tableList.map(({ tableKey, groupShellList }, tableIndex) => (
          <DealsDealTypeTable
            key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
            tableKey={tableKey}
            groupShellList={groupShellList}
            groupTableKey={groupTableKey}
            groupTableIndex={groupTableIndex}
            tableIndex={tableIndex}
          />
        ))}
      </S.TableCreatorTableListWrapper>
    </S.GroupTableWrapper>
  );
};

export default DealsDealTypeGroupTable;
